import { defaultTheme } from "../../shared/constants";
import { Icon } from "../icons";
import { TextField } from "../textField";
import { CSSProperties, useState } from "react";
import { Typography } from "../typography";
import { InputWithIcon } from "./searchField.styles";

type SearchFieldProps = {
  label?: string;
  placeholder?: string;
  initialValue?: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  sx?: CSSProperties;
  id?: string;
};

export const SearchField = (props: SearchFieldProps) => {
  const [fieldValue, setFieldValue] = useState(props.initialValue || "");
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {!!props.label && (
        <Typography
          style={{ marginBottom: "6px", color: defaultTheme.COLORS.GRAY_DARK }}
          variant="body-small"
          insensitive
        >
          {props.label}
          {props.required ? "*" : ""}
        </Typography>
      )}
      <InputWithIcon className="inputWithIcon">
        <div className="left-icon">
          <Icon.Search />
        </div>
        <TextField
          hideSensitiveData={false}
          disabled={props.disabled}
          value={fieldValue}
          placeholder={props.placeholder}
          onChange={(event) => {
            const newValue = event.target.value;
            props.onChange(newValue);
            setFieldValue(newValue);
          }}
          sx={props.sx}
          {...(props.id && { id: props.id })}
        />
      </InputWithIcon>
    </div>
  );
};
